import styled from 'styled-components'

import DiscountTag from 'client/components/DiscountTag'
import CarouselDots from 'src/comps/CarouselDots'

import { ImageBase } from '../Image/styles'
import { updatedMedia } from 'client/styles'

export const GalleryContainer = styled.div`
  position: relative;
`

export const GalleryBase = styled.div`
  display: flex;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  ${updatedMedia.tablet} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 400px 100px;
    gap: 20px;
  }

  ${updatedMedia.desktop} {
    height: 400px;
    grid-template-columns: 4fr 1.5fr 1.5fr;
    grid-template-rows: repeat(3, 1fr);
  }
`

export const Thumbnail = styled.div`
  flex: 0 0 auto;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  width: 100%;
  overflow: hidden;
  padding-block: 0;
  padding-inline: 0;

  ${updatedMedia.onlyMobile} {
    height: 266px;
  }

  ${ImageBase} {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
  }

  &:first-child {
    grid-column: 1 / -1;
    ${updatedMedia.desktop} {
      grid-row: span 3;
      grid-column: unset;
    }
  }

  ${updatedMedia.tablet} {
    border-radius: 8px;
    cursor: pointer;
  }
`

export const ShowMore = styled.div`
  display: none;
  ${updatedMedia.tablet} {
    display: flex;
    width: 100%;
    border-radius: 8px;
    cursor: pointer;
    background-color: ${props => props.theme.colors.grey1};
    justify-content: center;
    align-items: center;
    transition: 0.2s all;
    grid-column: span 5;
    &:hover {
      background-color: ${props => props.theme.colors.grey2};
    }
  }
  ${updatedMedia.desktop} {
    grid-column: unset;
  }
`

export const StyledDiscountTag = styled(DiscountTag)`
  position: absolute;
  inset-block-start: 12px;
  z-index: 1;
  ${updatedMedia.tablet} {
    inset-inline-start: 40px;
    inset-block-start: 60px;
  }
`

export const StyledCarouselDots = styled(CarouselDots)`
  ${updatedMedia.tablet} {
    display: none;
  }
`

export const HotelName = styled.span`
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: none;
  ${updatedMedia.onlyMobile} {
    display: block;
  }
`

export const GalleryTitle = styled.div`
  max-width: calc(100% - 56px);
  padding-block: 0;
  padding-inline: 20px;
  margin-inline: auto;
  margin-block: 0;

  ${updatedMedia.onlyTablet} {
    padding-block: 0;
    padding-inline: 0;
  }

  ${updatedMedia.onlyMobile} {
    max-width: 100%;
    padding-block: 0;
    padding-inline: 0;
  }
`
